import styled from 'styled-components';
export const MainContainer = styled.div `
  --max-container-width: 1440px;
  --side-padding: 5px;
  @media screen and (min-width: 480px) {
    --side-padding: 15px;
  }
  @media screen and (min-width: 768px) {
    --side-padding: 15px;
  }
  ${props => props.noMobilePadding && `
    @media screen and (max-width: 1440px) {
        --side-padding: 0px;
    }
  `}
  width: 100%;
  max-width: calc(2 * var(--side-padding) + var(--max-container-width));
  box-sizing: border-box;
  margin: 0 auto;
  padding: 0 var(--side-padding);
`;
